export default __webpack_public_path__ + "static/media/logo.f76ed4dc.png";